import React from 'react';
import { Link } from 'react-router-dom';
import { LuChevronRight } from 'react-icons/lu';

// Breadcrumb items: [{ label, to? }]; the last item renders as the current page.
export const Breadcrumb = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" className="flex w-auto flex-wrap items-center justify-start gap-1.5 text-sm text-muted-foreground">
    {items.map((item, i) => (
      <React.Fragment key={`${item.label}-${i}`}>
        {i > 0 && <LuChevronRight className="h-3.5 w-3.5" aria-hidden="true" />}
        {item.to && i < items.length - 1 ? (
          <Link to={item.to} className="transition-colors hover:text-foreground">
            {item.label}
          </Link>
        ) : (
          <span className="text-foreground" aria-current={i === items.length - 1 ? 'page' : undefined}>
            {item.label}
          </span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export const PageHeader = ({ title, subtitle, breadcrumb, actions, className = '' }) => (
  <div className={`mb-6 ${className}`}>
    {(breadcrumb || actions) && (
      <div className="mb-4 flex items-center justify-between gap-2">
        {breadcrumb ? <Breadcrumb items={breadcrumb} /> : <span />}
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    )}
    <h1 className="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">{title}</h1>
    {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
  </div>
);

export default PageHeader;
